import { render, staticRenderFns } from "./SystemUpdate.vue?vue&type=template&id=029ffa90&scoped=true"
import script from "./SystemUpdate.vue?vue&type=script&lang=js"
export * from "./SystemUpdate.vue?vue&type=script&lang=js"
import style0 from "./SystemUpdate.vue?vue&type=style&index=0&id=029ffa90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ffa90",
  null
  
)

export default component.exports